import React from 'react'
import { Header } from 'antd/es/layout/layout';
import { Button, Col, Row } from 'antd';
import Title from 'antd/es/typography/Title';


export default function PageHeader({title, buttonTitle, onClick, noButton}) {
  return (
    <Header className='bg-white p-0'>
        <Row className='mt-4'>
          <Col xs={12}>
            <Title level={3}>{title}</Title>
          </Col>
          {
            !noButton &&
            <Col xs={12} className='flex justify-end'>
              <Button type='primary' className='bg-green-600 align-middle' onClick={onClick}>
                {buttonTitle}
              </Button>
            </Col>
          }
        </Row>
    </Header>
  )
}
